import React, { useContext } from 'react';
import TitleGroup from '@atoms/TitleGroup/TitleGroup';
import Callout from '@atoms/Callout/Callout';
import Button from '@atoms/Button/Button';
import Section from '@atoms/Section/Section';
import OrderedCard from '@components/Card/OrderedCard';
import { useTranslation } from 'react-i18next';
import { ModalContext } from '@context/modal';
import MarkdownText from '@atoms/MarkdownText/MarkdownText';

interface Props {
    data: any;
    children?: React.ReactNode;
}
const CmsMappedComponent: React.FC<Props> = ({ data, children }) => {
    const { showModal } = useContext(ModalContext);
    const { t } = useTranslation();
    const renderEntryByType = () => {
        switch (data.__typename) {
            case 'AEPSYCMS_ComponentAtomsTitleGroup':
                return (
                    <TitleGroup
                        title={data.title}
                        subtitle={data.subtitle}
                        align="desktopCenter"
                    />
                );
            case 'AEPSYCMS_ComponentCommonOrderedCard':
                return (
                    <OrderedCard
                        highlightedText={data.highlightedText}
                        title={data.cardTitle || data.title}
                        subtitle={data.subtitle}
                        images={data.images}
                        badges={data.badges}
                        buttons={data.buttons}
                    >
                        {children && children}
                    </OrderedCard>
                );
            case 'AEPSYCMS_ComponentCommonZsrNumberCallout':
                return (
                    <Callout
                        border="giant"
                        padding="xl"
                        theme="purple"
                        variant="contained"
                        size="ml"
                        title={data.title}
                        text={data.subtitle}
                    >
                        <Section spacingTop="xs">
                            <Button
                                theme="white"
                                label={t('button.read')}
                                onClick={() =>
                                    showModal(
                                        <Section spacingTop="xs">
                                            <MarkdownText
                                                content={data.calloutContent}
                                            />
                                        </Section>,
                                        {
                                            title: data.title,
                                        }
                                    )
                                }
                            />
                        </Section>
                    </Callout>
                );
            default:
                return <></>;
        }
    };

    return <>{renderEntryByType()}</>;
};

export default CmsMappedComponent;
